import { IPaxInfo } from "../../../interfaces/searchFlight.interface";
import enquiryscss from "../../../sass/enquiry-list/Enquiry.module.scss";

export const EDPaxCount: React.FC<{
  paxCount: IPaxInfo;
}> = (props) => {
  return (
    <div className={`${enquiryscss.paxCountContainer} mt-3`}>
      <b> Pax Count: </b> <span> Adult:</span> {props.paxCount.ADULT} ,{" "}
      <span>Child: </span>
      {props.paxCount.CHILD} ,<span>Infant:</span> {props.paxCount.INFANT}
    </div>
  );
};
